
import ServicoByid from './servico'
import Servicos from './servicos'
import SalvarServico from './salvarServico'
import DeletarServico from './deletarServico'
 
export default {
    Servicos,     
    SalvarServico, 
    ServicoByid,   
    DeletarServico, 
    
}